/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionSortCriteria {
    getFixupPrototypeFunction() { return DimensionSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<DimensionSortCriteria>): DimensionSortCriteria {
        let obj = Object.assign(new DimensionSortCriteria(), model);
        DimensionSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionSortCriteria>): DimensionSortCriteria {
        if (!model) return null;
        return DimensionSortCriteria.newInstance(<DimensionSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionSortCriteria) {
        if (!obj) return;

        models.DimensionSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionSortCriteria): boolean {
        Object.setPrototypeOf(obj, DimensionSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.DimensionSortColumn;

    ascending: boolean;

}
